/* eslint-disable import/prefer-default-export */
import * as load from '../../../constants/types/shared/LoadingTypes';
import * as types from '../../../constants/types/sales/rescheduled-installations/RescheduledTypes';

export const rescheduledReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case load.LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
      };

    case load.LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
      };

    case types.GET_RESCHEDULED_REQUEST:
      return {
        ...state,
        lists: payload.lists,
        pages: payload.pages,
        count: payload.count,
        isLoading: false,
      };

    default:
      return state;
  }
};
